<template>
  <b-container>
    <m-factor-1/>
  </b-container>
</template>

<script>

export default {
  name: "Factor",
}
</script>

<style scoped>

</style>